import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { CollabDocumentContext } from '../../components/CollabDocumentProvider';

var SyncMonitoring =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SyncMonitoring, _React$Component);

  function SyncMonitoring(props, context) {
    var _this;

    _classCallCheck(this, SyncMonitoring);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SyncMonitoring).call(this, props, context));

    _defineProperty(_assertThisInitialized(_this), "onNothingPending", function () {
      _this.props.executeCallbacks();
    });

    _this.context.doc.on('nothing pending', _this.onNothingPending);

    return _this;
  }

  _createClass(SyncMonitoring, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.context.doc.removeListener('nothing pending', this.onNothingPending);
    }
  }, {
    key: "render",
    value: function render() {
      return false;
    }
  }]);

  return SyncMonitoring;
}(React.Component);

_defineProperty(SyncMonitoring, "contextType", CollabDocumentContext);

export default (function () {
  var callbacks = [];

  function onSyncDone(next) {
    if (callbacks.length > 0) {
      callbacks.forEach(function (callback) {
        callback();
      });
      callbacks = [];
    }

    return next();
  }

  return [{
    commands: {
      addOnSyncDoneCallback: function addOnSyncDoneCallback(editor, callback) {
        callbacks.push(callback);
      }
    },
    renderEditor: function renderEditor(props, editor, next) {
      var children = next();
      return React.createElement(React.Fragment, null, children, React.createElement(SyncMonitoring, {
        editor: editor,
        executeCallbacks: function executeCallbacks() {
          return onSyncDone(next);
        }
      }));
    }
  }];
});